import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import GroupHead from '@src/components/AdvertisingCampaign/Form/GroupHead'
import Row from '@src/components/AdvertisingCampaign/Form/Row'
import InputGroup from '@src/components/AdvertisingCampaign/Form/InputGroup'
import CheckableGroup from '@src/components/AdvertisingCampaign/Form/CheckableGroup'
import CheckboxGroup from '@src/components/AdvertisingCampaign/Form/CheckboxGroup'
import CardExample from '../CardExample'
import WorkTime from '../WorkTime'
import InputLabel from '@iui-kit/components/InputLabel'
import PhoneInput from '@iui-kit/components/PhoneInput'
import { Formik } from '@src/types/BriefSearch/formikProps'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import * as FIELDS from '@src/constants/AdvertisingBriefs'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepFour: React.FC<HOCProps> = (props: HOCProps) => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched, setFieldValue },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.search.step.four.title" notRequired={true}>
      <Row>
        <GroupHead title="Brief.search.step.four.head.title">
          <CardExample />
        </GroupHead>
        <InputGroup indent="l">
          <InputLabel
            size="l"
            name={FIELD_NAMES.CARD_EMAIL}
            label="Brief.search.field.cardEmail.label"
            value={values[FIELD_NAMES.CARD_EMAIL]}
            onChange={handleChange}
            handleBlur={handleBlur}
            isValid={!errors[FIELD_NAMES.CARD_EMAIL] || !touched[FIELD_NAMES.CARD_EMAIL]}
            placeholder={formatMessage({ id: 'Brief.search.field.cardEmail.placeholder' })}
          />
          <PhoneInput
            size="l"
            name={FIELD_NAMES.CARD_PHONE}
            label="Brief.search.field.cardPhone.label"
            value={values[FIELD_NAMES.CARD_PHONE]}
            handleBlur={handleBlur}
            isValid={!errors[FIELD_NAMES.CARD_PHONE] || !touched[FIELD_NAMES.CARD_PHONE]}
            setFieldValue={setFieldValue}
            placeholder={formatMessage({ id: 'Brief.search.field.cardPhone.placeholder' })}
          />
          <InputLabel
            size="l"
            name={FIELD_NAMES.CARD_CITY}
            label="Brief.search.field.cardCity.label"
            value={values[FIELD_NAMES.CARD_CITY]}
            onChange={handleChange}
            handleBlur={handleBlur}
            handleFocus={handleChange}
            isValid={!errors[FIELD_NAMES.CARD_CITY] || !touched[FIELD_NAMES.CARD_CITY]}
            placeholder={formatMessage({ id: 'Brief.search.field.cardCity.placeholder' })}
          />
          <InputLabel
            size="l"
            name={FIELD_NAMES.CARD_ADDRESS}
            label="Brief.search.field.cardAddress.label"
            value={values[FIELD_NAMES.CARD_ADDRESS]}
            onChange={handleChange}
            handleBlur={handleBlur}
            isValid={!errors[FIELD_NAMES.CARD_ADDRESS] || !touched[FIELD_NAMES.CARD_ADDRESS]}
            placeholder={formatMessage({ id: 'Brief.search.field.cardAddress.placeholder' })}
          />
        </InputGroup>
      </Row>
      <Row>
        <CheckableGroup label={'Brief.field.workDay.label'}>
          <CheckboxGroup name={FIELD_NAMES.CARD_WORKING_DAY} inputs={FIELDS.WORKING_DAYS} />
        </CheckableGroup>
      </Row>
      <Row>
        <WorkTime />
      </Row>
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepFour)
